const doc = [({"zh_cn":({"constantBookingErrorCode":({"no_data":"无法检索预订数据。", "unknown":"发生未知错误。"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;